import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { clearUserWatchlistCache } from '../hooks/useIndustries';
import { cancelPendingBackendRequests } from './backendRequestSession';

/**
 * Single logout code path shared by the manual "Log out" button and the
 * inactivity auto-logout timer, so both stay in sync.
 */
export async function performLogout(user) {
  // Pending backend requests belong to the authenticated session.
  // End them before waiting for Firebase so none can leak onto the login screen.
  cancelPendingBackendRequests();
  try {
    const uid = user?.uid;
    await signOut(auth);
    if (uid) clearUserWatchlistCache(uid);
  } catch (error) {
    console.error('Error signing out:', error);
  }
}
